import React, { useState } from "react";
import axios from "axios";
import WeatherForecast from "./WeatherForecast";

import WeatherContent from "./WeatherContent";
import "./WeatherReact.css";

export default function WeatherReact(props) {
  const [WeatherReactData, setWeatherReactData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);
  function WeatherReactResponse(response) {
    setWeatherReactData({
      ready: true,
      coordinates: response.data.coord,
      temperature: response.data.main.temp,
      humidity: response.data.main.humidity,
      wind: response.data.wind.speed,
      city: response.data.name,
      date: new Date(response.data.dt * 1000),
      description: response.data.weather[0].description,
      icon: response.data.weather[0].icon,
    });
  }

  function search() {
    const apiKey = "5f472b7acba333cd8a035ea85a0d4d4c";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(WeatherReactResponse);
  }
  function WeatherSubmit(event) {
    event.preventDefault();
    search();
  }

  function WeatherChangeCity(event) {
    setCity(event.target.value);
  }

  if (WeatherReactData.ready) {
    return (
      <div className="WeatherReact">
        <form onSubmit={WeatherSubmit}>
          <div className="row">
            <div className="col-9" mt-5>
              <input
                type="search"
                placeholder="Enter your country"
                autoComplete="off"
                autoFocus="on"
                className="form-control"
                onChange={WeatherChangeCity}
              />
            </div>
            <div className="col-2">
              <input type="submit" className="btn btn-primary" value="Search" />
            </div>
          </div>
        </form>
        <WeatherContent content={WeatherReactData} />
        <br />
        <WeatherForecast coordinates={WeatherReactData.coordinates} />
      </div>
    );
  } else {
    search();
    return <p>"The Result Weather is Loading......"</p>;
  }
}
